import Card from "../ui/card/Card";
import Icon from "../ui/Icon";
import Table from "../common/table/Table";
import React from "react";

const TableComponent = ({card}) => {
    return (
        <>
            <Card className="border-0 h-100 overflow-auto" style={{ minHeight: "250px", maxHeight: "350px" }}>
                <div className="d-flex flex-column gap-4">
                    <div className="d-flex flex-column gap-4">
                        <div className="d-flex align-items-start gap-2">
                            <div className={`card-icon p-2 bg-opacity-25 rounded-2 bg-${card.iconBgColor}`}>
                                <Icon name={card.icon} width={32} />
                            </div>
                            <div>
                                <h6 className="card-title fw-semibold lh-base mb-0">{card.title}</h6>
                                {card.subTitle &&
                                    Object.entries(card.subTitle).map(([key, value]) => (
                                        <p
                                            key={key}
                                            className={`card-subtitle m-0 fs-sm fs-xs fw-medium opacity-75 ${card.subTitleColor ?? ''}`}
                                        >
                                            {key} : {value}
                                        </p>
                                    ))}
                            </div>
                        </div>
                        <div className="table-col-sizing rounded-3 overflow-hidden">
                            <Table
                                className="mobile-responsive p-2"
                                columns={card?.tableColumns}
                                data={card?.items}
                            />
                        </div>
                    </div>
                </div>
            </Card>
        </>
    )
}

export default TableComponent